// @ts-strict-ignore
import {userCookieUtils} from 'common/report/util/user-identity-from-cookie';
import {UserLocalStorageHelper} from 'common/report/user-local-storage';
import {PersistedResizablePanelState} from 'common/components/resizable-panel/types';
import {LocalStorageKey} from 'common/report/constants';
import type {StorageManager} from 'common/contexts/storage-manager/types';
import {DEFAULT_PERSISTED_STATE} from 'common/components/resizable-panel/constants';

export function isResizablePanelCollapsed(params: {localStorageManager: StorageManager; storageKey: string}) {
  const userLocalStorageHelper = new UserLocalStorageHelper<PersistedResizablePanelState>({
    context: params.localStorageManager,
    namespace: LocalStorageKey.Panel,
  });

  const persistedState = userLocalStorageHelper.getItem({
    key: params.storageKey,
    userId: userCookieUtils.getUserIdentityFromCookie()?.id,
  });

  if (!persistedState) {
    return DEFAULT_PERSISTED_STATE.isCollapsed;
  }
  return persistedState.isCollapsed;
}
